import { useLanguageContext } from "../../../context/LanguageContext";
import ButtonPage from "../../../pages/buttons/button/ButtonPage";
import { useButtonCreateRouteValidator } from "../../validators/buttons/ButtonCreateRouteValidator";
import { RouteConfig } from "../RouteConfig";
import useButtonsRouteConfig from "./ButtonsRouteConfig";

/**
 * The route config which contains static information about the route
 * @returns {{ path, label, validator, getPage, getRouteElement }}
 */
function useButtonCreateRouteConfig() {
  const { translate } = useLanguageContext();

  return new RouteConfig()
    .setPath("/dashboard/buttons/create")
    .setLabel(
      translate("eva.main.entities.states.create", [
        {
          key: "entities",
          value: translate("eva.main.entities.button"),
        }
      ])
    )
    .setValidator(useButtonCreateRouteValidator())
    .setPage(<ButtonPage />)
    .setParent(useButtonsRouteConfig());
}

export default useButtonCreateRouteConfig;